// extracted by mini-css-extract-plugin
export var acitonButtons = "_h1-0";
export var additionalIcon = "_h1-f";
export var block = "_h1-1";
export var blockContent = "_h1-7";
export var blockDescription = "_h1-8";
export var blockIcon = "_h1-9";
export var blockTitle = "_h1-6";
export var border = "_h1-a";
export var center = "_h1-l";
export var edge = "_h1-b";
export var edgeLabel = "_h1-c";
export var edgePath = "_h1-d";
export var error = "_h1-e";
export var flowchart = "_h1-g";
export var flowchartContent = "_h1-h";
export var highlighted = "_h1-3";
export var hover = "_h1-4";
export var icon = "_h1-i";
export var left = "_h1-m";
export var navButton = "_h1-j";
export var navButtons = "_h1-k";
export var right = "_h1-n";
export var selected = "_h1-2";
export var small = "_h1-5";